/* Variant media filter (Wedance). For merged colour products, Dawn's built-in `hide_variants`
   relies on the storefront `attached_to_variant?` flag, which does NOT reflect variant images
   associated via the bulk Admin API (our merges). So we filter the gallery client-side instead:
   default shows every image; picking a Colour shows only that variant's image and hides the rest.
   Subscribes to the theme's variantChange pub-sub (published by product-info.js after a variant
   change), so it works with the Dawn 15 Section-Rendering picker. */
(function () {
  if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;
  if (!PUB_SUB_EVENTS.variantChange) return;

  function galleryFor(sectionId) {
    // media-gallery is a SIBLING of <product-info> (in the media column), not a child — so scope to
    // the whole product section, not the product-info element.
    var section = document.getElementById('MainProduct-' + sectionId) ||
                  document.querySelector('.section-' + sectionId + '-padding') || document;
    return section.querySelector('media-gallery') || document.querySelector('media-gallery');
  }

  // Show the selected colour's photo on variant change WITHOUT hiding the rest — the full gallery
  // stays visible (no collapse-jerk); we just bring the variant's featured media to the front / into
  // view. This keeps "full gallery on entry" while still surfacing the chosen colour.
  // Remember the media currently surfaced per section, so Size/Heel changes (which keep the same
  // colour → same featured media) do NOT re-scroll the gallery ("jerk"). Only a real colour change
  // (different featured media) moves the gallery. Initialised on load from the selected variant.
  var lastMedia = {};
  function showVariantMedia(sectionId, variant) {
    var gallery = galleryFor(sectionId);
    if (!gallery || !variant || !variant.featured_media) return;
    var mid = sectionId + '-' + variant.featured_media.id;
    if (lastMedia[sectionId] === mid) return; // same colour image → no jerk on Size/Heel change
    lastMedia[sectionId] = mid;
    // undo any leftover hiding from the previous (filter) behaviour
    gallery.querySelectorAll('.wd-media-hidden').forEach(function (li) { li.classList.remove('wd-media-hidden'); });
    var li = gallery.querySelector('li[data-media-id="' + mid + '"]');
    if (!li) return;
    // Bring the selected colour's photo to the FRONT so it's the one shown — full gallery kept, no
    // hide/collapse. (No-op when it's already first, e.g. Size/Heel changes keep the same colour photo.)
    var list = li.parentElement;
    if (list && list.firstElementChild !== li) list.insertBefore(li, list.firstElementChild);
    // Also drive Dawn's active-media state (slider position / zoom target) where available.
    if (typeof gallery.setActiveMedia === 'function') { try { gallery.setActiveMedia(mid, true); } catch (e) {} }
  }

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var data = (event && event.data) || {};
    showVariantMedia(data.sectionId, data.variant);
  });

  // On load, ensure the full gallery shows (clear any hidden state from the old filter version) and
  // seed lastMedia with the selected variant's media so the FIRST Size/Heel change doesn't jerk.
  function initState() {
    document.querySelectorAll('media-gallery .wd-media-hidden').forEach(function (li) { li.classList.remove('wd-media-hidden'); });
    document.querySelectorAll('variant-selects[data-section]').forEach(function (vs) {
      var sid = vs.getAttribute('data-section');
      var el = vs.querySelector('script[data-selected-variant]');
      if (!el) return;
      try { var v = JSON.parse(el.textContent); if (v && v.featured_media) lastMedia[sid] = sid + '-' + v.featured_media.id; } catch (e) {}
    });
  }
  if (document.readyState !== 'loading') initState(); else document.addEventListener('DOMContentLoaded', initState);
})();

/* Heel-height ascending sort (Wedance). New 1.6"/2" heights were appended after 2.5"–3.5" at the
   data level, so the picker showed them out of order. Reorder the Heel-height option's tiles (or
   dropdown options) numerically. Runs on load and re-runs after the Dawn 15 picker re-renders. */
(function () {
  function num(s) { var m = (s || '').match(/[\d.]+/); return m ? parseFloat(m[0]) : 0; }
  function sortHeel() {
    document.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input').forEach(function (fs) {
      var lg = fs.querySelector('legend, .form__label');
      if (!lg || !/heel height/i.test(lg.textContent || '')) return;
      var inputs = [].slice.call(fs.querySelectorAll('input[type="radio"]'));
      if (inputs.length) {
        inputs.map(function (inp) {
          var lbl = inp.nextElementSibling && inp.nextElementSibling.tagName === 'LABEL' ? inp.nextElementSibling : null;
          return { inp: inp, lbl: lbl, v: num(inp.value) };
        }).sort(function (a, b) { return a.v - b.v; })
          .forEach(function (p) { fs.appendChild(p.inp); if (p.lbl) fs.appendChild(p.lbl); });
      } else {
        var sel = fs.querySelector('select');
        if (sel) [].slice.call(sel.options).sort(function (a, b) { return num(a.value) - num(b.value); })
          .forEach(function (o) { sel.appendChild(o); });
      }
    });
  }
  /* Colour order: popular first, swatch-less patterns last, rest keep their order. */
  var FIRST = ['dark tan satin', 'tan leather'];
  var LAST = ['pewter patterned leather', 'flower print'];
  function reorderColour() {
    document.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input').forEach(function (fs) {
      var lg = fs.querySelector('legend, .form__label');
      if (!lg || !/colou?r|material/i.test(lg.textContent || '')) return;
      var inputs = [].slice.call(fs.querySelectorAll('input[type="radio"]'));
      if (!inputs.length) return;
      var rank = function (v) {
        var s = (v || '').toLowerCase().trim();
        var fi = FIRST.indexOf(s); if (fi > -1) return fi;                 // 0,1
        var li = LAST.indexOf(s); if (li > -1) return 100 + li;            // 100,101
        return 50;                                                         // middle (stable)
      };
      var pairs = inputs.map(function (inp, i) {
        var lbl = inp.nextElementSibling && inp.nextElementSibling.tagName === 'LABEL' ? inp.nextElementSibling : null;
        return { inp: inp, lbl: lbl, r: rank(inp.value), i: i };
      }).sort(function (a, b) { return a.r - b.r || a.i - b.i; });
      pairs.forEach(function (p) { fs.appendChild(p.inp); if (p.lbl) fs.appendChild(p.lbl); });
      // 2-column grid + left-aligned labels, forced inline so it survives re-renders that drop our theme CSS
      var two = window.matchMedia('(min-width: 750px)').matches;
      fs.style.setProperty('display', 'grid', 'important');
      fs.style.setProperty('grid-template-columns', two ? '1fr 1fr' : '1fr', 'important');
      fs.style.setProperty('gap', '.6rem', 'important');
      var lg2 = fs.querySelector('legend, .form__label'); if (lg2) lg2.style.setProperty('grid-column', '1 / -1', 'important');
      pairs.forEach(function (p) {
        if (p.inp) { p.inp.style.setProperty('position', 'absolute', 'important'); p.inp.style.setProperty('width', '1px', 'important'); p.inp.style.setProperty('height', '1px', 'important'); p.inp.style.setProperty('opacity', '0', 'important'); }
        if (p.lbl) {
          p.lbl.style.setProperty('width', '100%', 'important');
          p.lbl.style.setProperty('margin', '0', 'important');
          p.lbl.style.setProperty('display', 'flex', 'important');
          p.lbl.style.setProperty('align-items', 'center', 'important');
          p.lbl.style.setProperty('justify-content', 'flex-start', 'important');
          p.lbl.style.setProperty('text-align', 'left', 'important');
        }
      });
    });
  }
  /* "?" help toggle for made-to-order hints (e.g. Toe shape) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.mto-help');
    if (!btn) return;
    e.preventDefault();
    var hint = document.getElementById(btn.getAttribute('aria-controls'));
    if (!hint) return;
    var open = hint.hasAttribute('hidden');
    if (open) hint.removeAttribute('hidden'); else hint.setAttribute('hidden', '');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  function reorderAll() { sortHeel(); reorderColour(); }
  if (document.readyState !== 'loading') reorderAll(); else document.addEventListener('DOMContentLoaded', reorderAll);
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(reorderAll, 60); });
  }
})();
